const typography = {
  fontFamily: 'Open Sans',
  h1: {
    fontSize: '6.857rem',
    fontWeight: 300,
  },
  h2: { fontWeight: 300, fontSize: '4.429rem' },
  h3: { fontWeight: 400, fontSize: '3.429rem' },
  h4: { fontWeight: 400, fontSize: '2.429rem' },
  h5: { fontWeight: 600, fontSize: '1.714rem' },
  h6: { fontWeight: 700, fontSize: '1.430rem' },
  subtitle1: { fontWeight: 600, fontSize: '1.143rem' },
  subtitle2: { fontWeight: 600, fontSize: '1.143rem' },
  body1: {
    fontSize: '1rem',
    fontWeight: 400,
  },
  body2: {
    fontSize: '1rem',
    fontWeight: 600,
  },
  button: {
    fontSize: '1rem',
    fontWeight: 400,
    letterSpacing: '0.02857em',
    textTransform: 'none',
  },
  caption: {
    fontSize: '0.857rem',
    fontWeight: 400,
  },
}
export default typography
